import React, { useState, useEffect } from "react";
import ListarTelefonos from "./ListarTelefonos";
import { Spinner, clienteAxios, Portal } from "../../../shared/";
import { BotonAgregar } from "../../../shared/Estilos";
import FormTelefono from "./FormTelefono";

const Telefonos = ({ id, soloLectura }) => {
  const [loadingLocal, setLoadingLocal] = useState(null);
  const [telefonos, setTelefonos] = useState(null);
  const [consultar, setConsultar] = useState(true);
  const [Seleccionado, setSeleccionado] = useState(null);

  //modal
  const [isOpened, setOpened] = useState(false);
  const openModal = () => {
    setOpened(true);
    window.scrollTo(0, 0);
  };
  const closeModal = (cierro) => {
    if (cierro) {
      setOpened(false);
    }
    setConsultar(true);
    setSeleccionado(null);
  };
  //modal

  useEffect(() => {
    const cargar = async () => {
      if (!consultar) return;

      try {
        setLoadingLocal(true);
        const result = await clienteAxios.get("/personascontacto", {
          params: { id },
        });
        setTelefonos(result.data.telefonos);
        setLoadingLocal(null);
      } catch (e) {}
      setConsultar(null);
    };

    cargar();
  }, [consultar, Seleccionado, id]);

  return (
    <div className="center-block">
      <div className="row">
        {!soloLectura ? (
          <div className="col-sm">
            <div className="form-group">
              {!isOpened ? (
                <BotonAgregar
                  onClick={() => {
                    openModal();
                  }}
                  className="btn btn-dark"
                >
                  <i className="fa fa-plus-circle"></i> Agregar Telefono
                </BotonAgregar>
              ) : null}
            </div>
          </div>
        ) : null}
        <br></br>
      </div>

      <br></br>
      {loadingLocal || !telefonos ? (
        <Spinner />
      ) : (
        <ListarTelefonos
          telefonos={telefonos}
          setSeleccionado={setSeleccionado}
          openModal={openModal}
          setConsultar={setConsultar}
          soloLectura={soloLectura}
        />
      )}

      <Portal isOpened={isOpened} onClose={closeModal}>
        <FormTelefono
          idpersona={id}
          closeModal={closeModal}
          Seleccionado={Seleccionado}
        />
      </Portal>
    </div>
  );
};

export default Telefonos;
